import { get } from 'modules/api';

/**
 * Get hive pickups
 * @param {string} assemblyUuid
 * @returns {Promise<Object[]>}
 */
export const fetchAssemblyPickups = assemblyUuid => get(`pickups/assemblies/${assemblyUuid}`);
